import { AiInventoryJob } from './types';
import { AiSourcesError } from './aiSourcesApi';

export async function inventoryRequest<T>(
  systemId: string, token: string, signal: AbortSignal, suffix = '', body?: object,
): Promise<T> {
  const response = await fetch('https://keycloak.okton.com.br/platform-api/v1/admin/applications/'
    + encodeURIComponent(systemId) + '/ai-inventory' + suffix, {
    method: body ? 'POST' : 'GET', signal, credentials: 'include',
    headers: { Authorization: 'Bearer ' + token, 'Content-Type': 'application/json' },
    body: body ? JSON.stringify(body) : undefined,
  });
  const payload = await response.json();
  if (!response.ok) throw new AiSourcesError(payload.message || 'Não foi possível acessar o inventário.', response.status);
  return payload.data as T;
}

export const loadInventory = (systemId: string, token: string, signal: AbortSignal): Promise<AiInventoryJob[]> =>
  inventoryRequest(systemId, token, signal);
